module.exports = __webpack_public_path__ + "img/aihuk_logo_full_black.57b500c6.svg";